<div class="view" onsip-grid-placement-shelf>
  <div class="first-column">
    <section class="name">
      <div class="mat-body-1">{{ "ONSIP_I18N.NAME" | translate }}</div>
      <div [attr.data-cy]="E2eLocators.ADMIN_GROUP_VIEW_SHELVE_NAME">{{ group.address.name }}</div>
    </section>
    <section class="ring-strategy">
      <div class="mat-body-1">{{ "ONSIP_I18N.RING_STRATEGY" | translate }}</div>
      <div [attr.data-cy]="E2eLocators.ADMIN_GROUP_VIEW_ORDERING">
        {{
          (group.ordering === "parallel" ? "ONSIP_I18N.SIMULTANEOUS_RING" : "ONSIP_I18N.HUNT_GROUP")
            | translate
        }}
      </div>
    </section>
    <section class="ring-duration">
      <div class="mat-body-1">{{ "ONSIP_I18N.RING_DURATION" | translate }}</div>
      <div [attr.data-cy]="E2eLocators.ADMIN_GROUP_VIEW_RING_DURATION">
        {{ group.timeout }} {{ "ONSIP_I18N.SECONDS" | translate | lowercase }}
      </div>
    </section>
    <section class="failover">
      <div class="mat-body-1">{{ "ONSIP_I18N.FAILOVER" | translate | sentenceCase }}</div>
      @if (transferAddress) {
      <div>
        {{ transferAddress.addressType | singularAddressType }}: <br />
        {{ transferAddress.name }}
      </div>
      } @if (!transferAddress) {
      <div>n/a</div>
      }
    </section>
  </div>
  <div class="second-column">
    <section class="sip-address">
      <div class="mat-body-1">{{ "ONSIP_I18N.SIP_ADDRESS" | translate }}</div>
      <div>{{ group.address.username }}&#64;{{ group.address.domain }}</div>
    </section>
    <section class="extensions">
      <div class="mat-body-1">{{ "ONSIP_I18N.EXTENSIONS" | translate }}</div>
      @if(group.extensions.length) {
      <div [attr.data-cy]="E2eLocators.ADMIN_GROUP_EXTENSIONS">
        @for (extension of group.extensions; track extension) {
        <div>{{ extension | formatExtensions }}</div>
        }
      </div>
      } @else { No extensions added }
    </section>
  </div>
</div>
<div class="page-view-controls">
  <button
    mat-flat-button
    color="primary"
    [attr.data-cy]="E2eLocators.ADMIN_GROUP_VIEW_SHELVE_EDIT"
    (click)="clickedEditing.emit()"
  >
    {{ "ONSIP_I18N.EDIT_INFO" | translate }}
  </button>
</div>
